"use client";

import React from "react";
import { SavedViewsTabsContainer } from "./SavedViewsTabs/SavedViewsTabsContainer";
import type { SavedViewsTabsProps } from "./SavedViewsTabs/types";
import type { BaseEntity } from "../../UniversalCRMTable/types";

/**
 * SavedViewsTabs Component
 *
 * Renders saved views as horizontally-scrollable pill-style tabs.
 * Includes a "Main" tab for the default view, scroll controls, add button, and hover menus.
 *
 * Features:
 * - Pill-style buttons with active state highlighting
 * - Horizontal scroll with left/right arrow buttons
 * - Add button to create new saved views
 * - Hover menus for saved views (not config presets) with delete, share, favorite options
 * - Responsive design
 * - Memoized to prevent unnecessary re-renders
 */
export const SavedViewsTabs = React.memo(SavedViewsTabsContainer) as <T extends BaseEntity>(
  props: SavedViewsTabsProps<T>
) => React.ReactElement;
